// src/components/InfiniteRunnersDecks.jsx
import React, { useEffect, useState } from "react";
import axios from "axios";

export default function InfiniteRunnersDecks({ userId, cardName }) {
  const [relatedDecks, setRelatedDecks] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!userId || !cardName) return;
    setLoading(true);
    axios
      .get(
        `${process.env.REACT_APP_API_URL}api/data/snapDecks/user/${userId}/search/card/${encodeURIComponent(
          cardName
        )}`
      )
      .then((res) => {
        const filtered = res.data.filter((d) =>
          d.deckrank.toLowerCase().includes("infinite runners")
        );
        setRelatedDecks(filtered);
      })
      .catch((err) => console.error("Failed to load related decks:", err))
      .finally(() => setLoading(false));
  }, [userId, cardName]);

  if (loading)
    return (
      <p style={{ textAlign: "center", color: "#aaa", marginTop: "16px" }}>
        Loading related decks...
      </p>
    );

  if (relatedDecks.length === 0)
    return (
      <p style={{ textAlign: "center", color: "#888", marginTop: "16px" }}>
        This card does not appear in any <strong>Infinite Runners</strong> decks.
      </p>
    );

  return (
    <div style={{ marginTop: "24px" }}>
      <h3
        style={{
          textAlign: "center",
          color: "rgb(197,176,55)",
          marginBottom: "12px",
        }}
      >
        Infinite Runners:
      </h3>
      <ul
        style={{
          listStyle: "none",
          padding: 0,
          margin: "0 auto",
          display: "flex",
          flexWrap: "wrap",
          justifyContent: "center",
          maxWidth: "900px",
          gap: "12px",
        }}
      >
        {relatedDecks.map((deck) => (
          <li
            key={deck.id}
            style={{
              flex: "1 1 calc(33.33% - 24px)",
              maxWidth: "270px",
              minWidth: "100px",
              background: "rgba(255,255,255,0.05)",
              border: "1px solid rgba(255,255,255,0.1)",
              borderRadius: "8px",
              padding: "8px 12px",
              textAlign: "center",
            }}
          >
            <span style={{ color: "#fff" }}>{deck.deckname}</span>
            <span
              style={{
                color: "#888",
                marginLeft: "8px",
                fontSize: "0.9em",
              }}
            >
              (v{deck.versionnum})
            </span>
          </li>
        ))}
      </ul>
    </div>
  );
}
